export const GET_STORE_EARNING_RULES_START = 'GET_STORE_EARNING_RULES_START';
export const GET_STORE_EARNING_RULES_SUCCESS = 'GET_STORE_EARNING_RULES_SUCCESS';
export const GET_STORE_EARNING_RULES_FAILED = 'GET_STORE_EARNING_RULES_FAILED';

export const GET_STORE_SPENDING_RULES_START = 'GET_STORE_SPENDING_RULES_START';
export const GET_STORE_SPENDING_RULES_SUCCESS = 'GET_STORE_SPENDING_RULES_SUCCESS';
export const GET_STORE_SPENDING_RULES_FAILED = 'GET_STORE_SPENDING_RULES_FAILED';

export const SAVE_STORE_EARNING_RULES_START = 'SAVE_STORE_EARNING_RULES_START';
export const SAVE_STORE_EARNING_RULES_SUCCESS = 'SAVE_STORE_EARNING_RULES_SUCCESS';
export const SAVE_STORE_EARNING_RULES_FAILED = 'SAVE_STORE_EARNING_RULES_FAILED';

export const SAVE_STORE_SPENDING_RULES_START = 'SAVE_STORE_SPENDING_RULES_START';
export const SAVE_STORE_SPENDING_RULES_SUCCESS = 'SAVE_STORE_SPENDING_RULES_SUCCESS';
export const SAVE_STORE_SPENDING_RULES_FAILED = 'SAVE_STORE_SPENDING_RULES_FAILED';

export const GET_STORE_REWARD_BEHAVIOUR_RULES_START = 'GET_STORE_REWARD_BEHAVIOUR_RULES_START';
export const GET_STORE_REWARD_BEHAVIOUR_RULES_SUCCESS = 'GET_STORE_REWARD_BEHAVIOUR_RULES_SUCCESS';
export const GET_STORE_REWARD_BEHAVIOUR_RULES_FAILED = 'GET_STORE_REWARD_BEHAVIOUR_RULES_FAILED';

export const CHANGE_STORE_BEHAVIOUR_RULE_CONFIGS = 'CHANGE_STORE_BEHAVIOUR_RULE_CONFIGS';

export const SAVE_STORE_REWARD_BEHAVIOUR_RULES_START = 'SAVE_STORE_REWARD_BEHAVIOUR_RULES_START';
export const SAVE_STORE_REWARD_BEHAVIOUR_RULES_SUCCESS = 'SAVE_STORE_REWARD_BEHAVIOUR_RULES_SUCCESS';
export const SAVE_STORE_REWARD_BEHAVIOUR_RULES_FAILED = 'SAVE_STORE_REWARD_BEHAVIOUR_RULES_FAILED';

export const getStoreEarningRulesStart = () => ({
  type: GET_STORE_EARNING_RULES_START
});

export const getStoreEarningRulesSuccess = (data) => ({
  type: GET_STORE_EARNING_RULES_SUCCESS,
  data
});

export const getStoreEarningRulesFailed = () => ({
  type: GET_STORE_EARNING_RULES_FAILED
});

export const getStoreSpendingRulesStart = () => ({
  type: GET_STORE_SPENDING_RULES_START
});

export const getStoreSpendingRulesSuccess = (data) => ({
  type: GET_STORE_SPENDING_RULES_SUCCESS,
  data
});

export const getStoreSpendingRulesFailed = () => ({
  type: GET_STORE_SPENDING_RULES_FAILED
});

export const saveEarningRulesStart = () => ({
  type: SAVE_STORE_EARNING_RULES_START
});

export const saveEarningRulesSuccess = (data) => ({
  type: SAVE_STORE_EARNING_RULES_SUCCESS,
  data
});

export const saveEarningRulesFailed = () => ({
  type: SAVE_STORE_EARNING_RULES_FAILED
});

export const saveSpendingRulesStart = () => ({
  type: SAVE_STORE_SPENDING_RULES_START
});

export const saveSpendingRulesSuccess = (data) => ({
  type: SAVE_STORE_SPENDING_RULES_SUCCESS,
  data
});

export const saveSpendingRulesFailed = () => ({
  type: SAVE_STORE_SPENDING_RULES_FAILED
});

export const getStoreRewardBehaviourRulesStart = () => ({
  type: GET_STORE_REWARD_BEHAVIOUR_RULES_START
});

export const getStoreRewardBehaviourRulesSuccess = (data) => ({
  type: GET_STORE_REWARD_BEHAVIOUR_RULES_SUCCESS,
  data
});

export const getStoreRewardBehaviourRulesFailed = () => ({
  type: GET_STORE_REWARD_BEHAVIOUR_RULES_FAILED
});

export const changeBehaviourRuleConfigs = (keyName, checked, actionType, value, ruleName) => ({
  type: CHANGE_STORE_BEHAVIOUR_RULE_CONFIGS,
  keyName,
  checked,
  actionType,
  value,
  ruleName
});

export const saveStoreRewardBehaviourRulesStart = () => ({
  type: SAVE_STORE_REWARD_BEHAVIOUR_RULES_START
});

export const saveStoreRewardBehaviourRulesSuccess = () => ({
  type: SAVE_STORE_REWARD_BEHAVIOUR_RULES_SUCCESS
});

export const saveStoreRewardBehaviourRulesFailed = () => ({
  type: SAVE_STORE_REWARD_BEHAVIOUR_RULES_FAILED
});
